module.exports = "/_next/static/images/ipad_create_targets-5499486b0bc19cf2a2cd616b7edeceec.png";